import { AbortError, ensureAuthenticatedUser } from '@forest/paywall-core'
import {
  getReceiptSystemAccountIdSafe,
  native,
  type UserInfo,
} from '@forest/native-services'
import { appVersion } from '~/lib/params'
import { $receiptSystemAccountId, $userInfo } from '~/store'

export { AbortError }

export async function getAuthenticatedUserInfo(): Promise<UserInfo> {
  const userInfo = await ensureAuthenticatedUser({
    getUserInfo: async () => {
      const result = await native.user.getUserInfo()
      if (!result.success) throw new Error('getUserInfo failed')
      if (!result.data) throw new Error('getUserInfo returned null data')
      return { success: true as const, data: result.data }
    },
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onAfterGuestUpgrade: async () => {
      $receiptSystemAccountId.set(
        await getReceiptSystemAccountIdSafe(appVersion),
      )
    },
    onLegacyBindStart: () => {
      window.dispatchEvent(new CustomEvent('hide-close-button'))
    },
    onLegacyBindEnd: () => {
      window.dispatchEvent(new CustomEvent('show-close-button'))
    },
    onUserInfo: (nextUserInfo) => {
      $userInfo.set(nextUserInfo)
    },
  })

  return userInfo
}
